<template>
  <div>
    <Row>
      <Col
        class="menu-item"
        :xs="12"
        :sm="12"
        :md="8"
        :lg="6"
        :xl="3"
        v-for="(item, index) in contextMenuList"
        :key="index"
      >
        <img :src="require('../..//assets/' + item.icon)" style="width:60px" />
        <Checkbox v-model="item.show_flag">{{ $t(item.apply_name) }}</Checkbox>
      </Col>
    </Row>
    <div class="footer-btn">
      <Row type="flex" justify="center">
        <Col :xs="12" :sm="12" :md="6" :lg="4" :xl="2">
          <Button type="primary" @click="submit()">保存</Button>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      baseUrl: "/api/staticSiteIcon/",
      contextMenuList: [],
      userId: ""
    };
  },
  created() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userId = userInfo.serialnumber;
    axios
      .post("/context/getPowerMenuUpdate", { user_id: this.userId })
      .then(res => {
        if (res != null && res.length > 0) {
          this.contextMenuList = JSON.parse(JSON.stringify(res));
        }
      });
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    }
  },
  methods: {
    submit() {
      var newcontextMenuList = this.contextMenuList.filter(item => {
        return item.show_flag == true;
      });
      // if (newcontextMenuList.length > 0 && newcontextMenuList.length <= 6) {
      this.contextMenuList.forEach(item => {
        if (item.show_flag == "1") {
          item.show_flag = true;
        }
        if (item.show_flag == "0") {
          item.show_flag = false;
        }
      });
      this.$Modal.confirm({
        title: this.$notice("submission"),
        onOk: () => {
          this.contextMenuList.forEach(item => {
            item.user_id = this.userId;
          });
          axios.post("/context/update", this.contextMenuList).then(res => {
            this.$Message.success(this.$t("Save_Successful"));
            this.$router.push(
              "/710B8EBEFAFA4118E92BAF7238FF712F/A3FFBEBFDB713E27"
            );
          });
        }
      });
      // } else {
      //     this.$Message.error('请选择1至6个快捷菜单')
      // }
    }
  }
};
</script>

<style lang="less" scoped>
.menu-item {
  display: flex;
  flex-flow: column;
  align-items: center;
  cursor: pointer;
}
/deep/ .ivu-checkbox-wrapper {
  margin-right: 0px;
}
.footer-btn {
  margin-top: 25px;
  border-top: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/ContextMenuSetting.vue